export const editMutations = <const>{
	FAKTURACE_POJISTOVNA_SELECT_MAPPER: 'FAKTURACE_POJISTOVNA_SELECT_MAPPER',
	FAKTURACE_JINY_PRIJEMCE_SELECT_MAPPER: 'FAKTURACE_JINY_PRIJEMCE_SELECT_MAPPER',
	FAKTURACE_LEAS_ZAKAZNIK_SELECT_MAPPER: 'FAKTURACE_LEAS_ZAKAZNIK_SELECT_MAPPER',
};
